<div class="matches-shell fade-in">
	<section class="page-hero">
		<div>
			<span class="eyebrow"><fa-icon [icon]="icons.handshake"></fa-icon> Match Workspace</span>
			<h1 class="hero-title">Load Matches</h1>
			<p class="hero-copy">Review AI suggested possibilities, manual pairings, and confirmed bookings.</p>
		</div>

		<div class="hero-side">
			<div class="hero-stats">
				<div class="stat-card">
					<fa-icon [icon]="icons.listCheck"></fa-icon>
					<span class="stat-value">{{ totalRecords() || 0 }}</span>
					<span class="stat-label">Total matches</span>
				</div>
				<div class="stat-card">
					<fa-icon [icon]="icons.listCheck"></fa-icon>
					<span class="stat-value">{{ rows() }}</span>
					<span class="stat-label">Per page</span>
				</div>
			</div>

			<div class="hero-actions">
				<button type="button" pButton label="Create New Match" class="p-button-success action-button icon-button"
					[routerLink]="['/matches/create']">
					<fa-icon [icon]="icons.plus"></fa-icon>
				</button>
				<button pButton class="p-button-outlined p-button-secondary action-button icon-only-button"
					aria-label="Match settings">
					<fa-icon [icon]="icons.cog"></fa-icon>
				</button>
			</div>
		</div>
	</section>

	<section class="market-panel">
		<app-matches-list [matchGroups]="matchGroups()" [loading]="loading()" (actionClick)="onActionClick($event)">
		</app-matches-list>

		@if (!loading() && totalRecords() > 0) {
		<div class="pagination-panel">
			<p-paginator (onPageChange)="onPageChange($event)" [first]="first()" [rows]="rows()"
				[totalRecords]="totalRecords()" [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
		</div>
		}
	</section>
</div>
